export default __webpack_public_path__ + "static/media/survey_insight.ab22b5f6.svg";